import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ServiceItemProps } from "apis/service";
import { PaginationProps } from "utils/types/API";

export interface ServiceState {
    loading: boolean;
    list: {
        data: ServiceItemProps[];
        options: ServiceItemProps[];
        pagination?: PaginationProps;
    };
    item: {
        data?: ServiceItemProps;
    };
}

const initialState: ServiceState = {
    loading: false,
    list: {
        data: [],
        options: []
    },
    item: {
    }
};

interface IndexProps {
    data: ServiceItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: ServiceItemProps;
}
export const serviceSlice = createSlice({
    name: "service",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
        },
        options: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.options = action.payload.data;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, options, find, create, update } = serviceSlice.actions;
export default serviceSlice.reducer;
